import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsVideoPageNav from "templates/contentDetailsVideoPageNav.hbs";
import L from "lodash/fp";

class ContentDetailsVideoPageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
  }

  get template() {
    return templateContentDetailsVideoPageNav;
  }

  render() {
    const modelProps = this.model.toJSON();

    this.$el.html(
        this.template(
            L.merge(
                {
                  showComments: !this.organizationProperties.hideCommentsTab
                },
                modelProps,
            ),
        ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default ContentDetailsVideoPageNavView;
